import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT, STATIC_ROOT } from '../../../constants';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import DownloadBlock from './DownloadBlock';
import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './ToolbarPage.scss';

import SvgComponent from '../../SvgComponent';

export class ToolbarPage extends React.Component {
    render() {
        const { i18n } = this.props;
        return (
            <main className="conteneur conteneur-mobile" id="p-toolbar">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.TOOLBAR_PATH}`}
                />
                <LocalizedBreadcrumbItem to={PATH.TOOLBAR_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.PAGE_TITLE}</h1>

                <div className="bloc-toolbar">
                    <div className="explaination">
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT1)}</p>
                        <p>{i18n.TEXT2}</p>
                        <DownloadBlock />
                    </div>
                    <img
                        src={`${STATIC_ROOT}/toolbar/toolbar-visuel.png`}
                        className="visuel"
                        width="426"
                        height="297"
                        alt="toolbar"
                    />
                </div>

                <h3 className="sectionTitle">{i18n.SECTION_TITLE}</h3>
                <div className="explanationContainer">
                    <div className="explanationBloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/toolbar/HowItWorkToolbarPicto1.svg`}
                            width="62"
                            height="62"
                        />
                        <p>
                            {convertHtmlToReactDomWithParams(i18n.TEXT3)}
                            <LocalizedNavLink to={PATH.ACCOUNT_PATH} title={i18n.TEXT3_1}>
                                {i18n.TEXT3_1}
                            </LocalizedNavLink>
                        </p>
                    </div>
                    <div className="explanationBloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/toolbar/HowItWorkToolbarPicto2.svg`}
                            width="62"
                            height="62"
                        />
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT4)}</p>
                    </div>
                    <div className="explanationBloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/toolbar/HowItWorkToolbarPicto3.svg`}
                            width="62"
                            height="62"
                        />
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT5)}</p>
                    </div>
                </div>

                <div className="DownloadBloc">
                    <h3>{convertHtmlToReactDomWithParams(i18n.TEXT6)}</h3>
                    <p>{i18n.TEXT7}</p>
                    <DownloadBlock />
                </div>

                <div className="footer">
                    <img
                        src={`${STATIC_ROOT}/toolbar/toolbar-footer.png`}
                        width="1014"
                        height="341"
                        alt="toolbar footer"
                    />
                    <p>{i18n.FOOTER_TEXT}</p>
                </div>
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.TOOLBAR
    };
};

export default withTemplate(connect(mapStateToProps)(ToolbarPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/toolbar/ToolbarPage.js